import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import registerServiceWorker from './lib/registerServiceWorker';

/* ----- Reducers ----- */
import reducers from './reducers';

/* Containers */
import App from './containers/App';
import Bio from './containers/Bio';
import Other from './containers/Other';
import Artwork from './containers/Artwork';
import Design2 from './containers/Design2';
import MotoTrip from './containers/MotoTrip';
import BigHeads from './containers/BigHeads';
import Hawaii from './containers/Hawaii';
import Shade from './containers/Shade';
import JNKR from './containers/JNKR';
import Complicity from './containers/Complicity';
import Tintype from './containers/Tintype';
import Divercity from './containers/Divercity';
import Flickr from './containers/Flickr';
import ToDo from './containers/To-Do';
import Truisms from './containers/Truisms';

import Beer from './containers/Beer';
import Sounds from './containers/Sounds';

/* Sassy */
import './index.css';

/* ----- STORE ----- */
const store = createStore(
  reducers,
  applyMiddleware(thunk)
);

/* JSX */
ReactDOM.hydrate(
  <Provider store={ store }>
    <Router>
      <div id="source">
        <Route exact path="/" component={ App } />
        <Route exact path="/bio" component={ Bio } />
        <Route exact path="/other" component={ Other } />
        <Route exact path="/artwork" component={ Artwork } />
        <Route exact path="/design" component={ Design2 } />
        <Route exact path="/artwork/moto" component={ MotoTrip } />
        <Route exact path="/artwork/bigheads" component={ BigHeads } />
        <Route exact path="/artwork/hawaii" component={ Hawaii } />
        <Route exact path="/artwork/complicity" component={ Complicity } />
        <Route exact path="/artwork/tintype" component={ Tintype } />
        <Route exact path="/design/shade" component={ Shade } />
        <Route exact path="/design/jnkr" component={ JNKR } />
        <Route exact path="/design/flickr" component={ Flickr } />
        <Route exact path="/design/todo" component={ ToDo } />
        <Route exact path="/design/truisms" component={ Truisms } />
        <Route exact path="/design/divercity" component={ Divercity } />
        <Route exact path="/beer-recipes" component={ Beer } />
        <Route exact path="/sounds" component={ Sounds } />
      </div>
    </Router>
  </Provider>,

  document.getElementById('root')
);

registerServiceWorker();